import { render, staticRenderFns } from "./OrderableAddProductDialog.vue?vue&type=template&id=046645f7&"
import script from "./OrderableAddProductDialog.vue?vue&type=script&lang=ts&"
export * from "./OrderableAddProductDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports